import mailData from './mailData.js'

export const GenAiFaqData = [
    {
        General: [
            {
                id: 1,
                Question: "What Work Breakdown Structure (WBS) should be used for training?",
                Answer: `<p>For Level 1 course completions, there is currently no assigned WBSE. However, for Level 2 Instructor-led training, the respective training team will furnish the WBSE post the training.</p>`
            }
        ],
        AutomationEngineersOrDeliveryPractitioners: [
            {
                id: 1,
                Question: "How will this training apply to my work?",
                Answer: `<p>The Automation Engineer training program equips you with practical knowledge and skills in applying <b>Gen AI in the Technology Delivery Life Cycle (TDLC)</b>. You will learn how to implement Gen AI in hands-on roles related to Application or Infrastructure Management, Application Development, and System Integration programs, using Accenture assets and Ecosystem tools.</p>`
            },
            {
                id: 2,
                Question: "Why enroll for this training?",
                Answer: `<p>Enrolling in this training is crucial to stay relevant in the evolving landscape of Generative AI. It provides you with the must-have skills to leverage Gen AI opportunities, improve productivity, reduce cost and add value to the services delivered to our clients.</p>`
            },
            {
                id: 2,
                Question: "How do I check if I am eligible to apply for Automation Engineer trainings?",
                Answer: `<p>Eligibility criteria is the following:
                    <ul>
                        <li>The Automation Engineer training is intended for CL12 to CL8. You can check your career level (CL) to determine your eligibility.</li>
                        <li>If you fall within CL12 to CL8, you are eligible to apply for this training.</li>
                    </ul>
                    Level 1 trainings (Mandatory) <br />
                    <table>
                        <tr>
                            <th>S.No</th>
                            <th>Course Name</th>
                            <th>Duration</th>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>TQ - Artificial Intelligence & Gen AI</td>
                            <td>2 hours</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>AI/ML Essentials (Optional if aware of this topic)</td>
                            <td>2 hours</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Generative AI APIs for Practical Applications: An Introduction</td>
                            <td>1 hour</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Gen AI Essentials</td>
                            <td>4 hours</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>Gen AI - Foundational Elements to start building TDLC use cases</td>
                            <td>9.5 hours</td>
                        </tr>
                    </table>
                </p>`
            },
            {
                id: 3,
                Question: "What am I taught as part of Automation Engineer training?",
                Answer: `<p>The training covers practical applications of Gen AI, responsible use, Gen AI in TDLC use cases, and key skills in areas like Prompt Engineering, Vector Database, and Ecosystem tools. You will also gain an understanding of <b>Accenture GenWizard assets</b> to <b>fast-track client journeys</b>. <br />
                    Click <a href="https://mylearning.accenture.com/mylearningui/learner/coursedetail/2092817" target="_blank">here</a> to know more.
                </p>`
            },
            {
                id: 4,
                Question: "How can I register for this training?",
                Answer: `<p>You can register for the Automation Engineer training by clicking on the link here. Ensure that you complete Level-1, which is mandatory before attending Level-2 sessions.</p>`
            },
            {
                id: 5,
                Question: "How will this benefit Accenture?",
                Answer: `<p>The training equips you with skills to implement Gen AI in TDLC, making you a valuable asset in delivering enhanced services to clients. Your proficiency in Gen AI technologies contributes to Accenture's position as an innovative and competitive leader in the industry.</p>`
            },
            {
                id: 6,
                Question: "Who do I reach out to support in case I have any issues enrolling for training?",
                Answer: `<p>If you encounter issues or have questions about enrollment, you reach out to the designated support.
                    <ul>
                        <li>For any queries, you may reach out to <a href="mailTo:${mailData.automationPrime}">${mailData.automationPrime}</a></li>
                        <li>To check Automation Engineer certification/registration status you can write to <a href="mailTo:${mailData.automationUniversity}">Automation University</a>.</li>
                    </ul>
                </p>`
            }
        ],
        AutomationArchitect: [
            {
                id: 1,
                Question: "How will this training apply to my work?",
                Answer: `<p>The Automation Architect training program is designed to enhance your ability to identify applicable <b>Gen AI use cases in the Technology Delivery Life Cycle (TDLC)</b> for client engagements. It equips you with the skills to build a Gen AI automation roadmap, drive assets and automation adoption in TDLC, and gain in-depth knowledge of Accenture assets and ecosystem tools integration. This training empowers you to contribute significantly to the success of client engagements.</p>`
            },
            {
                id: 2,
                Question: "Why enroll for this training?",
                Answer: `<p>Enrolling in the Automation Architect training is essential for staying at the forefront of Gen AI technologies. This program enables you to play a crucial role in client engagements as an Automation Lead/Architect, driving Gen AI adoption, creating automation roadmaps, and ensuring the achievement of business outcomes. It positions you as a key contributor to the success and innovation of Accenture's client projects.</p>`
            },
            {
                id: 3,
                Question: "How do I check if I am eligible to apply for Automation Architect trainings (Write in bullets even for AE)",
                Answer: `<p>Eligibility criteria is the following:
                    <ul>
                        <li>The Automation Architect training is intended for individuals at CL9 and above, playing the role of Automation Lead/Architect on client engagements. You can check your career level (CL) to determine eligibility. </li>
                        <li>If you are at CL9 or above, you are eligible to apply for this training and have to get nominated from Market/MU/ATC leadership.
                        </li>
                    </ul>
                </p>`
            },
            {
                id: 4,
                Question: "How many levels of trainings are there?",
                Answer: `<p>The training program comprises two levels.
                    <ul>
                        <li>Level-1 includes 19 hours of mandatory digital learning boards covering essential and foundational elements of Gen AI, LLM models, Prompt Engineering, and some Ecosystem Tools. </li>
                        <li>Level-2 consists of 27 hours of virtual classroom sessions covering hands-on exercises on Accenture assets, Gen AI use cases implementation, client automation opportunity finding, roadmap creation, and business outcomes measurement.</li>
                    </ul>
                    Level 1 trainings (Mandatory)
                    <table>
                        <tr>
                            <th>S.No</th>
                            <th>Course Name</th>
                            <th>Duration</th>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>TQ - Artificial Intelligence & Gen AI</td>
                            <td>2 hours</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>AI/ML Essentials (Optional if aware of this topic)</td>
                            <td>2 hours</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Generative AI APIs for Practical Applications: An Introduction</td>
                            <td>1 hour</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Gen AI Essentials</td>
                            <td>4 hours</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>Gen AI - Foundational Elements to start building TDLC use cases</td>
                            <td>9.5 hours</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>Automation Architecture - Previous Course Recap</td>
                            <td>6 hours</td>
                        </tr>
                    </table>
                </p>`
            },
            {
                id: 5,
                Question: "What am I taught as part of Automation Architect training?",
                Answer: `<p>The training covers essential and foundational elements of Gen AI, LLM models, Prompt Engineering, and Ecosystem Tools. <br />
                    Additionally, Level-2 includes hands-on exercises on Accenture assets, GenWizard, asset installation and configuration, Gen AI use cases implementation for TDLC (AMS, IMS, SI Custom, SI SAP), client automation opportunity finding, roadmap creation, and business outcomes measurement. <br />
                    Click <a href="https://mylearning.accenture.com/mylearningui/learner/coursedetail/2094373" target="_blank">here</a> to know more
                </p>`
            },
            {
                id: 6,
                Question: "How can I register for this training?",
                Answer: `<p>Interested participants can register for Level-1 of the Automation Architect training by clicking here. However, please note that registration for Level-2 is based on selection and nominations from Market/MU/ATC leadership. Nominated participants will receive program and registration details in a separate email.</p>`
            },
            {
                id: 7,
                Question: "How will this benefit Accenture?",
                Answer: `<p>The training enhances your capabilities to drive Gen AI adoption in client engagements, create automation roadmaps, and ensure the achievement of business outcomes. Your expertise contributes to Accenture's reputation as an innovative and forward-thinking leader in the industry, providing a competitive edge in client projects.</p>`
            },
            {
                id: 6,
                Question: "Who do I reach out to support in case I have any issues enrolling for training?",
                Answer: `<p>If you encounter issues or have questions about enrollment, you reach out to the designated support.
                    <ul>
                        <li>For any queries, you may reach out to <a href="mailTo:${mailData.automationPrime}">${mailData.automationPrime}</a></li>
                        <li>To check Automation Architect certification/registration status you can write to <a href="mailTo:${mailData.automationUniversity}">Automation University</a>.</li>
                    </ul>
                </p>`
            },
        ],
        DeliveryLeads: [
            {
                id: 1,
                Question: "How will this training apply to my work?",
                Answer: `<p>The Delivery Leads training program is designed to enhance your ability to identify applicable <b>Gen AI use cases in the Technology Delivery Life Cycle (TDLC)</b> for client engagements. It equips you with the skills to build a Gen AI automation roadmap, drive assets and automation adoption in TDLC, and gain in-depth knowledge of Accenture assets and ecosystem tools integration. This training empowers you to contribute significantly to the success of client engagements.</p>`
            },
            {
                id: 2,
                Question: "Why enroll for this training?",
                Answer: `<p>Enrolling in Delivery Leads training is essential for staying at the forefront of Gen AI technologies. This program enables you to:
                    <ul>
                        <li>Understand our competitive differentiation of Assets.</li>
                        <li>Be able to hold client conversations using “show-n-tell” approach and originate opportunities.</li>
                        <li>Understand solution and commercial model considerations and assess impact on existing solutions.</li>
                        <li>Understand asset and ecosystem tools deployment models, provisioning considerations and initiate Gen AI use cases in delivery.</li>
                        <li>Monitor and measure outcomes from Gen AI use cases to assess productivity benefits and overall business value.</li>
                    </ul>
                </p>`
            },
            {
                id: 3,
                Question: "How do I check if I am eligible to apply for Delivery Leads trainings",
                Answer: `<p>Eligibility criteria is the following:
                    <ul>
                        <li>This training is intended for Delivery Leads (xDL) and Tech Services Leads of Application or Infrastructure Management engagements and System Integration programs at CL 6 and above. You can check your career level (CL) to determine eligibility.
                        </li>
                    </ul>
                </p>`
            },
            {
                id: 4,
                Question: "How many levels of trainings are there?",
                Answer: `<p>The training program comprises two levels.
                    <ul>
                        <li>Level-1 includes 18 hours of mandatory digital learning boards covering essential and foundational elements of Gen AI, LLM models, Prompt Engineering, and some Ecosystem Tools.</li>
                        <li>Level-2 consists of 9 hours of virtual classroom sessions covering hands-on exercises on Accenture assets. </li>
                    </ul>
                    Level 1 trainings
                    <table>
                        <tr>
                            <th>Course Name</th>
                            <th>Course Duration</th>
                            <th>Training Requirement</th>
                        </tr>
                        <tr>
                            <td>Generative AI API’s for Practical Application: An Introduction</td>
                            <td>1 hour</td>
                            <td>Optional</td>
                        </tr>
                        <tr>
                            <td>Gen AI Essentials (DL/TSL)</td>
                            <td>3.5 hours</td>
                            <td>Mandatory</td>
                        </tr>
                        <tr>
                            <td>Gen AI – Foundational Elements to Start Building TDLC Use Cases</td>
                            <td>9.5 hours</td>
                            <td>Optional</td>
                        </tr>
                    </table>
                </p>`
            },
            {
                id: 5,
                Question: "What am I taught as part of Delivery lead training?",
                Answer: `<p>The training covers mandatory digital learning boards covering essential and foundational elements of Gen AI, LLM models, Prompt Engineering, and some Ecosystem Tools.
                    Additionally, Level-2 includes hands-on exercises on Accenture assets. <br />
                    Click <a href="https://mylearning.accenture.com/mylearningui/learner/coursedetail/2107272" target="_blank">here</a> to know more
                </p>`
            },
            {
                id: 6,
                Question: "How can I register for this training?",
                Answer: `<p>Participants need to register separately for online and instructor led courses. Click <a href="https://mylearning.accenture.com/mylearningui/learner/coursedetail/2107272" target="_blank">here</a> to register for online training, For online courses registration, select all online courses checkbox and click on register button. Please note that the practitioners who have the nominations from the leaders are prioritized for the training.</p>`
            },
            {
                id: 7,
                Question: "How will this benefit Accenture?",
                Answer: `<p>The training enhances your capabilities to drive Gen AI adoption in client engagements, create automation roadmaps, and ensure the achievement of business outcomes. Your expertise contributes to Accenture's reputation as an innovative and forward-thinking leader in the industry, providing a competitive edge in client projects.</p>`
            },
            {
                id: 8,
                Question: "Who do I reach out to support in case I have any issues enrolling for training?",
                Answer: `<p>If you encounter issues or have questions about enrollment, you reach out to the designated support.
                    <b> In case of any queries write to:</b>
                    <ul>
                        <li>For ATCI participants
                            <ul>
                                <li style={{ listStyleType: "circle" }}><a href="mailTo:${mailData.automationMail}">${mailData.automationMail}</a></li>
                            </ul>
                        </li>
                        <li>For Non ATCI participants
                            <ul>
                                <li style={{ listStyleType: "circle" }}><a href="mailTo:${mailData.automationLearn}">${mailData.automationLearn}</a></li>
                            </ul>
                        </li>
                    </ul>
                </p>`
            },
            {
                id: 9,
                Question: "Do people who completed Gen AI Automation Architect training, still need to do DL/TSL training?",
                Answer: `<p>It is not mandatory. Participants need to complete the training as per the role that they are playing.
                    <b>Enrollment for Delivery Practitioner/ Automation Architect/ Delivery lead level 1 training</b>
                    <ol>
                        <li>Click on the level 1 registration link mentioned in the FAQ document to navigate to the page.</li>
                        <li>Click on check boxes for all the online courses and then click on “Register”.</li>
                        <li>You will be able to register for instructor led course/ Level 2 training only after completing all online level 1 modules.</li>
                    </ol>
                    <img src="images/FAQ/Screenshot.png" alt="screenshot" className="screenshot" /><br />
                    Note: The process for level 1 training remains the same across all 3 trainings. It is mandatory to complete level 1 training before registering for level 2 training.
                </p>`
            }
        ]
    }
]